class completeLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiperContainer = this.querySelector('[complete-look-slider]');
    const slides = this.querySelectorAll('[complete-look-slider] [complete-look-swiper-slide]');
    if (!swiperContainer || slides.length === 0) return;
    const slidesPerViewDesktop = parseFloat(swiperContainer.getAttribute('data-slides-per-view'));
    const slidesPerViewMobile = parseFloat(swiperContainer.getAttribute('data-slides-per-view-mobile'));
    const isMobile = window.innerWidth < 750;
    let requiredSlides;
    if (isMobile) {
      requiredSlides = slidesPerViewMobile;
    } else {
      requiredSlides = slidesPerViewDesktop;
    }
    if (slides.length > requiredSlides) {
      new Swiper(swiperContainer, {
        slidesPerView: slidesPerViewDesktop,
        loop: false,
        simulateTouch: true,
        touchStartPreventDefault: false, 
        scrollbar: {
          el: this.querySelector('[complete-look-swiper-scrollbar]'),
          draggable: true,
          hide: false
        },
        breakpoints: {
          0: {
            slidesPerView: slidesPerViewMobile + 0.9,
            spaceBetween: 12
          },
          768: {
            slidesPerView: slidesPerViewDesktop,
            spaceBetween: 0
          }
        },
        on: {
          touchStart(swiper, event) {
            const isExcluded = event.target.closest('[data-product-card-swiper-active]');
            const isClickable = event.target.closest('[data-product-card-title]');
            if (!isExcluded && !isClickable) {
              swiper.allowTouchMove = true;
            } else {
              swiper.allowTouchMove = false;
            }
          },
          touchEnd(swiper) {
            swiper.allowTouchMove = false;
          }
        }
      });
    }
  }
}

customElements.define('complete-look', completeLook);